export class RtClmSightCodeApi {
    constructor(public id: any, public name: string, public description: string) {}
}
